/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalSubmissionListEntry } from './PalSubmissionListEntry';
import {
    PalSubmissionListEntryFromJSON,
    PalSubmissionListEntryFromJSONTyped,
    PalSubmissionListEntryToJSON,
} from './PalSubmissionListEntry';

/**
 * 
 * @export
 * @interface FindAllPalSubmissionsResponse
 */
export interface FindAllPalSubmissionsResponse {
    /**
     * 
     * @type {Array<PalSubmissionListEntry>}
     * @memberof FindAllPalSubmissionsResponse
     */
    data: Array<PalSubmissionListEntry>;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalSubmissionsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalSubmissionsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalSubmissionsResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllPalSubmissionsResponse
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape. Typed as an open object because the openapi-generator's TypeScript template emits broken FromJSON for typed-additionalProperties Records; consumers cast at use site.
     * @type {{ [key: string]: any; }}
     * @memberof FindAllPalSubmissionsResponse
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllPalSubmissionsResponse interface.
 */
export function instanceOfFindAllPalSubmissionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllPalSubmissionsResponseFromJSON(json: any): FindAllPalSubmissionsResponse {
    return FindAllPalSubmissionsResponseFromJSONTyped(json, false);
}

export function FindAllPalSubmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalSubmissionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalSubmissionListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': !exists(json, 'users_sidecar') ? undefined : json['users_sidecar'],
    };
}

export function FindAllPalSubmissionsResponseToJSON(value?: FindAllPalSubmissionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PalSubmissionListEntryToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
        'users_sidecar': value.users_sidecar,
    };
}

